function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#FFC107",
  d: "M7.629 27.344c7 13.656 21 14.656 21 14.656 5.031-4.802 8.534-12.235 8.534-12.235l-14.778-8.403c0-.001-6.319 7.329-14.756 5.982z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#B3E5FC",
  d: "M8 6a2 2 0 100 4 2 2 0 100-4zm6.5 2a1.5 1.5 0 100 3 1.5 1.5 0 100-3zM13 13a3 3 0 100 6 3 3 0 100-6z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#3F51B5",
  d: "M36.277 21.209l-.481.877-6.099-3.469.494-.869 7.291-10.984c.735-.911 2.108-.988 3.147-.333 1.067.547 1.636 1.734 1.248 2.719l-5.6 12.059z"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#3F51B5",
  d: "M35.408 20.714l-4.348-2.471c-3.477-1.978-6.204-1.229-8.181 2.249l-.495.869 14.778 8.403.494-.868c1.979-3.476 1.228-6.204-2.248-8.182z"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#F57C00",
  d: "M20.145 23.438c.286.636.765 1.558 1.52 2.091.022.017.048.024.071.04l.001.002c.962.678 2.151.929 3.551.759.265.714.747 1.563 1.633 2.188.021.015.047.023.07.039l.002.001c.964.68 2.148.93 3.549.76.267.715.748 1.563 1.633 2.188.115.082.234.158.355.227.059.034.129.05.189.079.83.44 1.989.592 3.098.485 1.013-1.632 1.347-2.532 1.347-2.532l-14.778-8.403c-.948.948-.932.918-2.241 2.076z"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#FB8C00",
  d: "M14.564 34.255c1.268-.162 5.436-.838 8.145-5.088-3.708 4.25-10.829 3.242-12.22 2.657a26.33 26.33 0 002.236 2.503c.495.032 1.09.019 1.839-.072zm2.679 3.658a28.121 28.121 0 003.508 1.879l.02.008c.318-.092.663-.206 1.054-.363 1.32-.678 4.341-2.27 6.884-6.229-3.918 4.287-9.076 4.681-11.466 4.705z"
});

var Svg22Broom = function Svg22Broom(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    width: 96,
    height: 96,
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(Svg22Broom, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/22-broom.0a1192d3.svg";
export { ForwardRef as ReactComponent };